import { APIMethod, fetchData } from "@client";

export async function getProjectPresetQuery(keyOrProjectUuid) {
  const res = await fetchData(`/preset/project/${keyOrProjectUuid}`, APIMethod.GET);
  return res.results?.id ? res.results : undefined;
}
